module.exports = __webpack_public_path__ + "static/media/mblb.bd760307.png";